import { BASE_API_URL } from "utils/constants";
import { downloadFileGet, downloadFilePostNew, get, post } from '../../utils/api';
import { DataResponse } from "services/response";

// ================================== KHÁCH HÀNG CHƯA ĐỊNH DANH =================================
export interface CustomerUnidentifiedModel {
  stt: number;
  id: string;
  source: string;
  customerCode: string;
  customerName: string;
  deviceName: string;
  email: string;
  phone: string;
  firstVisit: string;
  visitsLast30Days: number;
  catalogDownloads: number;
  numberOfFavoriteProducts: number;
  numberOfColorMap: number;
  isCheck: boolean;
}



// ============ Khai báo phương thức =====================
export interface ICustomerUnidentifiedServices {
  // danh sách khách hàng chưa định danh
  getLisCustomerUnidentified(data: object): Promise<DataResponse<Array<CustomerUnidentifiedModel>>>

  // xóa khách hàng chưa định danh
  deleteCustomerUnidentified(data: object): Promise<DataResponse<any>>

  // export data khách hàng chưa định danh
  exportData(data: object): Promise<void>;

  // download template excel import khách hàng chưa định danh
  downloadTemplateExcel(): Promise<void>;

  // import excel khách hàng chưa định danh
  importExcel(data: object): Promise<DataResponse<null>>

  // create
  createCampaignAnonymous(data: object): Promise<DataResponse<null>>
}
// Hàm khởi tạo các phương thức của  service
export function createCustomerUnidentifiedServices(): ICustomerUnidentifiedServices {
  return {
    // danh sách khách hàng chưa định danh
    getLisCustomerUnidentified: async (data) => {
      return (await post(BASE_API_URL, `CustomerAnonymous/list`, data)).data;
    },
    deleteCustomerUnidentified: async (data) => {
      return (await post(BASE_API_URL, `CustomerAnonymous/delete`, data)).data;
    },
    exportData: async (data) => {
      return await downloadFilePostNew(BASE_API_URL, `CustomerAnonymous/export-excel-khcdd`, data);
    },

    // download template excel import khách hàng chưa định danh
    downloadTemplateExcel: async () => {
      return await downloadFileGet(`CustomerAnonymous/download-template-excel-khcdd`);
    },
    // import excel khách hàng chưa định danh
    importExcel: async (data: object) => {
      return (await post(BASE_API_URL, `CustomerAnonymous/import-excel-khcdd`, data)).data
    },

    // create
    createCampaignAnonymous: async (data: object) => {
      return (await post(BASE_API_URL, `CustomerAnonymous/create-campaign-anonymous`, data)).data
    },
  };
}
